/* istanbul ignore next */
import Vue from "vue";
let   isServer = Vue.prototype.$isServer;

/* istanbul ignore next */
export let   on = (function() {
	if (!isServer && document.addEventListener) {
		return function(element, event, handler) {
			if (element && event && handler) {
				element.addEventListener(event, handler, false);
			}
		};
	} else {
		return function(element, event, handler) {
			if (element && event && handler) {
				element.attachEvent("on" + event, handler);
			}
		};
	}
})();
